import React from "react";
import { Button } from "./ui/button";
import { Star } from "lucide-react";

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById("cta");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1673154548238-458890f64093?auto=format&fit=crop&w=1920')",
        }}
      >
        <div className="absolute inset-0 bg-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center text-white">
        <div className="max-w-4xl mx-auto space-y-6">
          <p className="text-lg md:text-xl font-medium tracking-wider uppercase">Quality Floors</p>
          
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight">
            Residential & Commercial<br />Epoxy Flooring Expert
          </h1>
          
          <p className="text-xl md:text-2xl font-light">Professional Epoxy Floor Installer</p>
          
          <div className="flex items-center justify-center gap-2 py-4">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="fill-yellow-400 text-yellow-400" size={24} />
            ))}
          </div>
          
          <p className="text-lg md:text-xl">Rated 5 stars by customers</p>
          
          <div className="pt-6">
            <Button
              onClick={scrollToContact}
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-lg rounded-md transition-all hover:scale-105"
            >
              Contact Now
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white rounded-full mt-2"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;